/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _containerClick = __webpack_require__(1);

	var _containerClick2 = _interopRequireDefault(_containerClick);

	var _customTabs = __webpack_require__(2);

	var _customTabs2 = _interopRequireDefault(_customTabs);

	var _elementRelocation = __webpack_require__(3);

	var _elementRelocation2 = _interopRequireDefault(_elementRelocation);

	var _equalHeights = __webpack_require__(5);

	var _equalHeights2 = _interopRequireDefault(_equalHeights);

	var _expandButton = __webpack_require__(6);

	var _expandButton2 = _interopRequireDefault(_expandButton);

	var _formSubmit = __webpack_require__(7);

	var _formSubmit2 = _interopRequireDefault(_formSubmit);

	var _jsFormValidate = __webpack_require__(8);

	var _jsFormValidate2 = _interopRequireDefault(_jsFormValidate);

	var _changeRegionLanguage = __webpack_require__(9);

	var _changeRegionLanguage2 = _interopRequireDefault(_changeRegionLanguage);

	var _changeText = __webpack_require__(10);

	var _changeText2 = _interopRequireDefault(_changeText);

	var _counter = __webpack_require__(11);

	var _counter2 = _interopRequireDefault(_counter);

	var _menu = __webpack_require__(12);

	var _menu2 = _interopRequireDefault(_menu);

	var _messages = __webpack_require__(13);

	var _messages2 = _interopRequireDefault(_messages);

	var _preloader = __webpack_require__(14);

	var _preloader2 = _interopRequireDefault(_preloader);

	var _readMoreButton = __webpack_require__(15);

	var _readMoreButton2 = _interopRequireDefault(_readMoreButton);

	var _readMoreLess = __webpack_require__(16);

	var _readMoreLess2 = _interopRequireDefault(_readMoreLess);

	var _search = __webpack_require__(17);

	var _search2 = _interopRequireDefault(_search);

	var _select = __webpack_require__(18);

	var _select2 = _interopRequireDefault(_select);

	var _select2Ajax = __webpack_require__(19);

	var _select2Ajax2 = _interopRequireDefault(_select2Ajax);

	var _sliders = __webpack_require__(20);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _sliderVideo = __webpack_require__(21);

	var _sliderVideo2 = _interopRequireDefault(_sliderVideo);

	var _stickyHeader = __webpack_require__(22);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	var _congressLoadMore = __webpack_require__(23);

	var _congressLoadMore2 = _interopRequireDefault(_congressLoadMore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	jQuery(function () {
		// Site Menu.
		_menu2.default.init();

		// Slick Slider.
		_sliders2.default.init();

		// Sticky header
		_stickyHeader2.default.init();

		// Frontend form validation.
		_jsFormValidate2.default.init();

		// Messages.
		_messages2.default.init();

		// Select 2.
		_select2.default.init();

		// Form Submit
		_formSubmit2.default.init();

		// Select 2 ajax
		_select2Ajax2.default.init();

		// Equal heights
		_equalHeights2.default.init();

		// Element relocation
		_elementRelocation2.default.init();

		// Search
		_search2.default.init();

		//Custom Tabs
		_customTabs2.default.init();

		//Increment Number
		_counter2.default.init();

		//Change Text
		_changeText2.default.init();

		//Preloader
		// Preloader.init();

		//Change Region & Language
		_changeRegionLanguage2.default.init();

		//Expand Button
		_expandButton2.default.init();

		//Slider Video
		_sliderVideo2.default.init();

		//Sectors entire card click
		_containerClick2.default.init();

		//Read More Button
		_readMoreButton2.default.init();

		// Read more/less toggler
		_readMoreLess2.default.init();

		// Congress Load More
		_congressLoadMore2.default.init();

		$(document).ajaxComplete(function () {
			//Form Submit
			_formSubmit2.default.init();

			// Select 2 ajax
			_equalHeights2.default.init();

			//Expand Button
			_expandButton2.default.init();

			// Frontend form validation
			_jsFormValidate2.default.init();
		});
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var ContainerClick = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    //Sectors listing
	    var $page = $('.page-node-195269');
	    var $columns = $page.find('.field-field_columns').find('.paragraph--type--column');

	    $columns.each(function (i, el) {
	      var $link = $(el).find('.field-field_link').find('a');
	      var $container = $link.closest('.paragraph--type--column');

	      $container.on('click', function () {
	        window.location.href = $link.attr('href');
	      });
	    });

	    // Google translate language picker
	    jQuery(document).ready(function ($) {
	      var $switcher = $('.gt_switcher');
	      var $selected = $switcher.find('.gt_selected a');
	      var $options = $switcher.find('.gt_option');

	      $selected.on('click', function (e) {
	        e.preventDefault();
	        $options.toggleClass('show');
	      });

	      $(document).on('click', function (e) {
	        if (!$(e.target).closest('.gt_switcher').length) {
	          $options.removeClass('show');
	        }
	      });

	      $options.find('a').on('click', function () {
	        $options.removeClass('show');
	      });
	    });
	  }
	};

	exports.default = ContainerClick;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var CustomTabs = {

	    init: function init() {
	        var $domLanguages = $('.languages');
	        var $domLanguagesLinks = $('.languages a');
	        var selectedValue = $('.languages a').eq(0).html();
	        $domLanguagesLinks.wrapAll('<div class="link-wrapper"></div>');
	        $domLanguages.prepend('<div class="select-language">' + selectedValue + '</div>');
	        var $domLinkWrapper = $('.link-wrapper');
	        var $domSelectLanguage = $('.select-language');
	        var $domBody = $('.body-wrapper');
	        // const $formEmbedded = $('.action-network-embed');
	        var $domBodyText = $domBody.children();
	        // const $formEmbeddedText = $formEmbedded.children();

	        $domBodyText.eq(0).addClass('visible');
	        // $formEmbeddedText.eq(0).addClass('visible');

	        $domLinkWrapper.on('click', function () {
	            $domLinkWrapper.toggleClass('visible');
	        });

	        // Check for "lang" parameter in URL and set initial active language
	        var urlParams = new URLSearchParams(window.location.search);
	        var activeLang = urlParams.get('lang');

	        if (activeLang) {
	            // Set active language based on URL parameter
	            $domLanguagesLinks.each(function (index, item) {
	                if ($(item).text().trim() === activeLang) {
	                    $(item).trigger('click'); // Trigger click on the matching language link
	                    $domSelectLanguage.html(activeLang); // Update displayed selected language
	                }
	            });
	        }

	        $domLanguages.on('click', function (e) {
	            e.preventDefault();
	            $domSelectLanguage.toggleClass('open');
	            var $this = $(e.target);
	            $domSelectLanguage.html($this.html());
	        });

	        $domLanguages.on('click', function (e) {
	            e.preventDefault();
	            $domLinkWrapper.toggleClass('open');
	            var $this = $(e.target);
	            $domSelectLanguage.html($this.html());
	        });

	        $domLanguagesLinks.each(function (LinkIndex, item) {
	            $(item).on('click', function (e) {
	                e.preventDefault();

	                $domBodyText.each(function (index, item) {
	                    if (LinkIndex === index) {
	                        $(item).addClass('visible');
	                    } else {
	                        $(item).removeClass('visible');
	                    }
	                });

	                // $formEmbeddedText.each((index, item) => {
	                //     if (LinkIndex === index) {
	                //         $(item).addClass('visible');
	                //     } else {
	                //         $(item).removeClass('visible');
	                //     }
	                // })
	            });
	        });

	        // New tabs.
	        var $domFieldDownloads = $('.field-field_downloads');
	        var $domFieldItems = $domFieldDownloads.children();
	        $domFieldItems.wrapAll('<div class="language-wrapper"></div>');
	        var $domDownloadHref = $domFieldItems.find('a');
	        var languageValue = $domDownloadHref.eq(0).html();
	        var downloadLink = $domDownloadHref.eq(0).attr('href');
	        // console.log(downloadLink);
	        $domFieldDownloads.prepend('<div class="select-language">' + languageValue + '</div>');
	        var $domSelectLanguage1 = $('.select-language');
	        var $domLanguageWrapper = $('.language-wrapper');
	        $domFieldDownloads.append('<div class="e-btn download-button">Download</div>');
	        var $domDownloadButton = $('.download-button');
	        $('.language-wrapper, .select-language').wrapAll('<div class="wrapper"></div>');

	        $domSelectLanguage1.on('click', function () {
	            $domSelectLanguage1.toggleClass('open');
	            $domLanguageWrapper.toggleClass('open');
	        });

	        $domDownloadHref.on('click', function (e) {
	            e.preventDefault();
	            var $this = $(e.target);
	            downloadLink = $this.attr('href');
	            $domSelectLanguage1.html($this.html());
	            $domSelectLanguage1.removeClass('open');
	            $domLanguageWrapper.removeClass('open');
	        });

	        $domDownloadButton.on('click', function () {
	            var a = document.createElement('a');
	            a.href = downloadLink;
	            a.download = downloadLink.split('/').pop();
	            document.body.appendChild(a);
	            a.click();
	            document.body.removeChild(a);
	        });

	        // Store value of clicked language from dropdown to URL 
	        $(document).ready(function () {
	            $('.page-node-campaigns .tab-link').on('click', function (event) {
	                event.preventDefault();

	                var title = $(this).text().trim();

	                var newUrl = '' + window.location.origin + window.location.pathname + '?lang=' + title;
	                window.history.pushState({ path: newUrl }, '', newUrl);
	                window.location.href = newUrl;
	            });
	        });
	    }
	};

	exports.default = CustomTabs;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _global = __webpack_require__(4);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var ElementRelocation = {
	    /*-------------------------------------------------------------------------------
	    	# Cache dom and strings
	    -------------------------------------------------------------------------------*/
	    /*-------------------------------------------------------------------------------
	    	# Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        if ($('body').hasClass('page-node-global_basic_page') || $('body').hasClass('page-node-story') || $('body').hasClass('page-node-news') || $('body').hasClass('page-taxonomy-in_focus') || $('body').hasClass('page-taxonomy-sector') || $('body').hasClass('page-node-campaigns') || $('body').hasClass('page-node-events') || $('body').hasClass('page-node-reports_publications') || $('body').hasClass('page-node-videos') || $('body').hasClass('page-vote') || $('body').hasClass('page-taxonomy-tags') || $('body').hasClass('page-node-homepage_slider') || $('body').hasClass('page-node-project_page') || $('body').hasClass('page-node-page')) {
	            var $domPageTitle = $('#block-itf-page-title');
	            $domPageTitle.prependTo('.layout-container');

	            $(".layout-container .banner-image, #block-itf-page-title, #block-photoprize2024, #block-itf-photoprize2024vote").wrapAll("<div class='banner-wrapper'></div>");
	            if ($('.field-field_banner_icons').length) {
	                $('.banner-wrapper').addClass('icon-exist');
	            }
	        }

	        if ($('body').hasClass('page-node-199129')) {
	            $('.slick-dots').wrap('<div class="dots-caption-wrapper"></div>');
	            $('.slick-current .field-field_caption').clone().insertAfter('.slick-dots');

	            $('#block-photoprize2024pagesliderfooter .field-field_caption').prependTo('#block-photoprize2024pagesliderfooter');
	            $('#block-photoprize2024pagesliderfooter .field-field_caption').wrap('<div class="caption-wrapper"></div>');
	        }

	        if ($('body').hasClass('page-node-200672')) {

	            var $divWeeks = Drupal.t('Weeks');
	            var $divDays = Drupal.t('Days');
	            var $divHours = Drupal.t('Hours');
	            var $divMinutes = Drupal.t('Minutes');
	            var $divSeconds = Drupal.t('Seconds');

	            if ($('.countWeeks').length) {
	                $('.countWeeks').append('<div class="time-text">' + $divWeeks + '</div>');
	            }

	            if ($('.countDays').length) {
	                $('.countDays').append('<div class="time-text">' + $divDays + '</div>');
	            }

	            if ($('.countHrs').length) {
	                $('.countHrs').append('<div class="time-text">' + $divHours + '</div>');
	            }

	            if ($('.countMins').length) {
	                $('.countMins').append('<div class="time-text">' + $divMinutes + '</div>');
	            }

	            if ($('.countSecs').length) {
	                $('.countSecs').append('<div class="time-text">' + $divSeconds + '</div>');
	            }
	        }
	    }
	};

	exports.default = ElementRelocation;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Global = {
		$domWindow: $(window),
		$domDoc: $(document),
		$domBody: $('body'),

		varsWindowWidth: window.innerWidth,

		functions: {
			escKey: function escKey(callback) {
				Global.$domDoc.on('keyup', function (e) {
					if (e.keyCode === 27) {
						callback();
					}
				});
			},

			clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
				selector.on('mouseup', function (e) {
					e.preventDefault();
					if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
						callback();
					}
				});
			}
		}
	};

	exports.default = Global;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(4);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var EqualHeights = {
	  /*-------------------------------------------------------------------------------
	  	# Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  /*-------------------------------------------------------------------------------
	  	# Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    // equal heights function
	    var equalHeights = function equalHeights(elm) {
	      setTimeout(function () {
	        var x = 0;

	        elm.height('auto');

	        elm.each(function (index, el) {
	          if ($(el).height() > x) {
	            x = $(el).height();
	          }
	        });

	        elm.height(x + 1);
	      }, 100);
	    };

	    //Campaigns
	    equalHeights($('.node--type-campaigns > div > h2'));
	    equalHeights($('.view-display-id-block_1 .node--type-campaigns div h2'));

	    //Events listing
	    equalHeights($('.node--type-events div h2'));

	    //Stories listing
	    equalHeights($('#views-exposed-form-stories-block-1 .form-radios .form-item label'));

	    //Resource single
	    equalHeights($('.page-node-reports_publications .field-field_pdf_document_chapters .paragraph--type--pdf-chapters .field-field_title'));
	  }
	};

	exports.default = EqualHeights;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var ExpandButton = {
		/*-------------------------------------------------------------------------------
	 # Cache dom and strings
	 -------------------------------------------------------------------------------*/

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// hide all tags
			var hideAllTags = function hideAllTags(tags) {
				tags.removeClass('show-tags');
			};

			// show all tags
			var showAllTags = function showAllTags(tags) {
				tags.addClass('show-tags');
			};

			// toggle all tags
			var toggleAllTags = function toggleAllTags(ellipsis) {
				// if two rows exist
				if (ellipsis.prev().hasClass('show-tags')) {
					hideAllTags(ellipsis.prev());
					ellipsis.find('a').text('...');
				} else {
					showAllTags(ellipsis.prev());
					ellipsis.find('a').html('&#x2715');
				}
			};

			var $domFieldTags = $('.tags-wrapper');

			// create ellipsis
			var ellipsis = '<span class="field--item ellipsis-toggle"><a>...</a></span>';

			$domFieldTags.each(function (index, tag) {
				// creating new container
				if (!Array.from($(tag).parent('.tags-wrapper-container')).length) {
					$(tag).wrap('<div class="tags-wrapper-container"</div>');
					$(tag).css({
						width: 'calc(100% - 33px)' // 33px - ellipsis width
					});
				}

				// add expand button
				var tagsInner = $(tag).children()[0];
				var combWidth = 0;
				var $tag = $(tag);
				var $domFieldItem = $tag.children().children();
				$domFieldItem.detach().appendTo(tagsInner);
				$domFieldItem.each(function (i, item) {
					// combWidth += $(item).width()
					combWidth += $(item).outerWidth(true);
				});

				if ($tag.width() <= combWidth) {
					if ($tag.parent().children().length === 1) {
						$tag.parent().append(ellipsis);
					}

					var $domToggleEllipsis = $tag.parent().find('.ellipsis-toggle');
					$domToggleEllipsis.on('click', function (e) {
						toggleAllTags($domToggleEllipsis);
						e.stopImmediatePropagation();
					});
				}

				if ($tag.height() > 33) {
					hideAllTags($tag);
				}
			});
		}
	};

	exports.default = ExpandButton;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(4);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var FormSubmit = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			var $domSearchButton = $('label[for*="edit-title"]');

			$domSearchButton.on('click', function () {
				var $domSubmitAffiliatesBtn = $('input[id*="edit-submit-itf-affiliates"]');

				$domSubmitAffiliatesBtn.click();
			});

			var $domSearchButtonStories = $('label[for*="edit-search-api-fulltext"]');
			var $domSubmitResourcesBtn = $('input[id*="edit-submit-resources-landing"]');
			var $domSubmitProjectsBtn = $('input[id*="edit-submit-projects-landing"]');
			var $domVideoContainer = $('.view-header').closest('[id*="block-views-block-resources"]');

			$domSearchButtonStories.on('click', function () {
				var $domSubmitNewsBtn = $('input[id*="edit-submit-news"]');
				var $domSubmitStoriesBtn = $('input[id*="edit-submit-stories"]');
				var $domSubmitSearchBtn = $('input[id*="edit-submit-search"]');
				var $domSubmitCampaignsBtn = $('input[id*="edit-submit-campaigns"]');

				$domSubmitNewsBtn.click();
				$domSubmitStoriesBtn.click();
				$domSubmitSearchBtn.click();
				$domSubmitCampaignsBtn.click();
				$domSubmitResourcesBtn.click();
				$domSubmitProjectsBtn.click();

				$domVideoContainer.addClass('hide-video');
			});

			$domSubmitResourcesBtn.click(function () {
				$domVideoContainer.addClass('hide-video');
			});

			$domSubmitProjectsBtn.click(function () {
				$domVideoContainer.addClass('hide-video');
			});

			var $domFormRadios = $('.form-radios input');

			$domFormRadios.each(function (index, item) {
				$(item).on('change', function () {
					var $domStoriesForm = $('form[id*="views-exposed-form-stories-block-1"]');
					var $domSubmitNewsBtn = $('input[id*="edit-submit-news"]');
					var $domSubmitStoriesBtn = $('input[id*="edit-submit-stories"]');

					$domSubmitNewsBtn.click();
					$domSubmitStoriesBtn.click();
				});
			});
		}
	};

	exports.default = FormSubmit;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(4);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var FormValidate = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		// Use this class for every form you whant to validate
		classForm: '.js-validation',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			if ($(FormValidate.classForm).length > 0) {
				$.validate({
					form: FormValidate.classForm
				});
			}

			////// form validation //////
			var $domIdForm = $('.views-exposed-form');
			var $domSearchForm = $('#search-form');

			// affiliates, news, stories..., photo repository
			var inputField = $domIdForm.find('.js-form-item .form-text');
			var button = $domIdForm.find('label[for*="edit-search-api-fulltext"], label[for*="edit-title"], input[id*="edit-submit-photography-competition"]');

			button.css('pointer-events', 'none');

			var toggleButton = function toggleButton() {
				if (inputField.val().length < 3) {
					$domIdForm.addClass('is-form-valid');
					button.css('pointer-events', 'none');
				} else {
					$domIdForm.removeClass('is-form-valid');
					button.css('pointer-events', 'initial');
				}

				$(window).on('keydown', function (event) {
					if (event.keyCode == 13) {
						if (inputField.val().length < 3) {
							event.preventDefault();
							return false;
						}
					}
				});
			};

			var onBlur = function onBlur() {
				$domIdForm.removeClass('is-form-valid');

				if (inputField.val().length < 3) {
					button.css('pointer-events', 'none');
				} else {
					button.css('pointer-events', 'initial');
				}
			};

			inputField.on('blur', onBlur);
			inputField.on('focus', toggleButton);
			inputField.on('keyup', toggleButton);

			////// search form
			var inputSearch = $domSearchForm.find('.js-form-item').find('.form-search');
			var buttonSearch = $domSearchForm.find('input[id*="edit-submit"]');

			buttonSearch.css('pointer-events', 'none');

			var toggleButtonSearch = function toggleButtonSearch() {
				if (inputSearch.val().length < 3) {
					buttonSearch.addClass('is-form-valid');
					buttonSearch.css('pointer-events', 'none');
				} else {
					buttonSearch.removeClass('is-form-valid');
					buttonSearch.css('pointer-events', 'initial');
				}

				$(window).on('keydown', function (event) {
					if (event.keyCode == 13) {
						if (inputSearch.val().length < 3) {
							event.preventDefault();
							return false;
						}
					}
				});
			};

			inputSearch.on('focus', toggleButtonSearch);
			inputSearch.on('keyup', toggleButtonSearch);
		}
	};

	exports.default = FormValidate;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var ChangeRegionLanguage = {
	    /*-------------------------------------------------------------------------------
	    # Cache dom and strings
	    -------------------------------------------------------------------------------*/

	    $domBlockRegion: $('#block-region'),
	    $domBlockLanguage: $('#block-languageswitchercontent'),

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        var dropMenu = function dropMenu(selector) {
	            var $regionMenu = $(selector).children('ul');
	            var $linkActive = $(selector).find('ul').find('a.is-active');
	            $(selector).find('h2').addClass('visually-hidden');

	            // if no active class use global (first element)
	            if (!$linkActive.length) {
	                $linkActive = $(selector).children('ul').children('li').first().children().addClass('is-active');
	            }

	            var regionCurrentListClass = '';
	            var regionCurrentClass = $linkActive.first().attr('class');
	            var regionCurrentText = $linkActive.first().text();

	            // if language switcher
	            if ($(selector).attr('id') === 'block-languageswitchercontent') {
	                regionCurrentListClass = $linkActive.parent('li').attr('class');
	            }

	            // wrap and prepend elements
	            $regionMenu.wrap('<div class="custom-dropdown"></div>');
	            $(selector).find('.custom-dropdown').prepend('\n                <span class="custom-dropdown-current ' + regionCurrentClass + ' ' + regionCurrentListClass + '">\n                    <span>' + regionCurrentText + '</span>\n                </span>\n            ');

	            $(selector).addClass('is-loaded');
	        };

	        dropMenu(ChangeRegionLanguage.$domBlockRegion);
	        dropMenu(ChangeRegionLanguage.$domBlockLanguage);
	    }
	};

	exports.default = ChangeRegionLanguage;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var ChangeText = {
		/*-------------------------------------------------------------------------------
	 # Cache dom and strings
	 -------------------------------------------------------------------------------*/

		$domCampaignPageTitle: $('.banner-image.bg-neon-yellow'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			var text = ChangeText.$domCampaignPageTitle.text();
			ChangeText.$domCampaignPageTitle.text('');
			ChangeText.$domCampaignPageTitle.append('<span>' + text + '</span>');

			// $(document).ready(function () {
			// 	$(".view-news-blocks:not(.view-display-id-block_1) .view-content .views-row article h2 span, .view-news .view-content .views-row article h2 span").each(function () {
			// 		let $el = $(this);
			// 		let originalText = $el.text();
			// 		let words = originalText.split(" ");
			// 		let lineHeight = parseInt($el.css("line-height"), 10);
			// 		let maxHeight = lineHeight * 3; // Ensure text is fully displayed for 2 lines

			// 		// Set necessary styles for multi-line truncation
			// 		$el.css({
			// 			"max-height": maxHeight + "px",
			// 			"overflow": "hidden",
			// 			"display": "block",
			// 			"white-space": "normal",
			// 			"position": "relative"
			// 		});

			// 		let tempText = originalText;
			// 		$el.text(tempText); // Reset text before measuring

			// 		// Only start trimming if text exceeds 2 lines
			// 		if ($el[0].scrollHeight > maxHeight) {
			// 			while ($el[0].scrollHeight > maxHeight && words.length > 0) {
			// 				words.pop(); // Remove last word
			// 				tempText = words.join(" ") + "...";
			// 				$el.text(tempText);
			// 			}
			// 		}
			// 	});
			// });			  
		}
	};

	exports.default = ChangeText;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var Counter = {
	    /*-------------------------------------------------------------------------------
	    # Cache dom and strings
	    -------------------------------------------------------------------------------*/

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        var $countList = $('.paragraph--type--counting-list');

	        if ($countList.length) {
	            $countList.each(function (i, el) {
	                var counter = 1;

	                $(el).find('.block-counting-list').find('.field--item').each(function (i, el) {
	                    if ($(el).find('.paragraph--type--list').find('.field-field_title').length) {
	                        if (counter < 10) {
	                            counter = '0' + counter;
	                        }

	                        $(el).find('.paragraph--type--list').find('.field-field_title').prepend('<span>' + counter + ' ' + '</span>');
	                        counter++;
	                    }
	                });
	            });
	        }
	    }
	};

	exports.default = Counter;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(4);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Menu = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domMenuBtn: $('.js-menu-btn'),
		$domMenuNav: $('.js-main-nav'),
		$domMenuHasSub: $('.js-main-nav .menu-item--expanded'),
		classOpen: 'open',
		classOpenMenu: 'menu-open',
		classSubMenu: '.menu-item--expanded > .menu',
		classSubIcon: '.sub-icon',
		classMenu: '.menu',
		classList: 'li',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			$('.js-menu-btn').clone().appendTo('#site-navigation > div');

			// functions
			var closeNav = function closeNav() {
				$('.js-menu-btn').removeClass(Menu.classOpen);
				Menu.$domMenuNav.removeClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass(Menu.classOpen);
				_global2.default.$domBody.removeClass(Menu.classOpenMenu);
			};

			if (_global2.default.varsWindowWidth < 992) {
				Menu.$domMenuHasSub.each(function (i, el) {
					$(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
				});
			}

			// bind events
			$('.js-menu-btn').on('click', function (e) {
				e.preventDefault();
				$('.js-menu-btn').toggleClass(Menu.classOpen);
				Menu.$domMenuNav.toggleClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass('open');
				_global2.default.$domBody.toggleClass(Menu.classOpenMenu);
			});

			Menu.$domMenuNav.on('click', '[data-open-sub]', function (e) {
				var self = $(e.currentTarget);

				if (self.hasClass(Menu.classOpen)) {
					self.removeClass(Menu.classOpen).siblings(Menu.classSubMenu).slideUp();
					self.siblings().find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.siblings().find(Menu.classMenu).slideUp();
				} else {
					self.addClass(Menu.classOpen).siblings(Menu.classSubMenu).slideDown();
					self.parent().siblings(Menu.classList).find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.parent().siblings(Menu.classList).find(Menu.classMenu).slideUp();
				}
			});

			$('.menu-item--expanded').each(function (index, item) {
				var $domHref = $(item).children('a');
				$domHref.append('<span class="toggle-dropdown"></span>');
				$domHref.children('span').on('click', function (e) {
					e.stopPropagation();
					e.preventDefault();
					$domHref.siblings().toggleClass('open');
					$domHref.children('span').toggleClass('open');
				});
			});

			_global2.default.functions.escKey(closeNav);
			_global2.default.functions.clickOutsideContainer(Menu.$domMenuNav, $('#site-navigation > div'), Menu.$domMenuBtn, closeNav);
		}
	};

	exports.default = Menu;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Messages = {

	  init: function init() {

	    $('div[role="contentinfo"]').append('<div class="close-button"></div>');

	    function closeFlashMessages() {
	      $('body').find('div[role="contentinfo"] .close-button').on('click', function (e) {
	        $('div[role="contentinfo"]').addClass('hide');
	      });
	    }

	    closeFlashMessages();

	    $(document).ajaxComplete(function () {
	      closeFlashMessages();
	    });
	  }
	};

	exports.default = Messages;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var Preloader = {
	    /*-------------------------------------------------------------------------------
	    # Cache dom and strings
	    -------------------------------------------------------------------------------*/

	    $domBody: $('body'),

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/

	    init: function init() {
	        Preloader.$domBody.addClass('page-loaded');
	        Preloader.$domBody.removeClass('throbber');
	    }
	};

	exports.default = Preloader;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var ReadMoreButton = {
	    /*-------------------------------------------------------------------------------
	    	# Cache dom and strings
	    -------------------------------------------------------------------------------*/
	    $domDescription: $('.page-node-global_basic_page .block-counting-list .field--name-field-desc'),

	    /*-------------------------------------------------------------------------------
	    	# Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {

	        var readMore = Drupal.t("Read more");
	        var readLess = Drupal.t("Read less");

	        ReadMoreButton.$domDescription.each(function (i, el) {
	            var $el = $(el);

	            if ($el.height() >= 160) {
	                $el.css({
	                    maxHeight: 160,
	                    overflow: 'hidden'
	                });

	                $el.parent().append('<div class="read-more-less-container show"><button class="read-more-less font-icon-chevron-right">' + readMore + '</button></div>');

	                var $button = $el.parent().find('button.read-more-less');

	                $button.on('click', function () {
	                    $button.toggleClass('less');
	                    $button.parent().toggleClass('show');

	                    if ($button.hasClass('less')) {
	                        $button.parent().prev().css({
	                            maxHeight: 'initial'
	                        });

	                        $button.text(readLess);
	                    } else {
	                        $el.css({
	                            maxHeight: 160
	                        });

	                        $button.text(readMore);
	                    }
	                });
	            }
	        });
	    }
	};

	exports.default = ReadMoreButton;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var ReadMoreLess = {
	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    if ($('body').hasClass('page-shortlist')) {
	      var truncate = function truncate(source, size) {
	        return source.length > size ? source.slice(0, size - 1) + "…" : source;
	      };

	      $('.node--type-photography-competition').each(function (i, el) {
	        $(el).find('.field-body').children('.field--item').addClass('body-text');

	        if ($(el).find('.field-body').children('.field--item').length) {
	          $(el).find('.field-body').children('.field--item').addClass('body-text');
	        } else {

	          if (!$(el).find('.field-body').children().length) {
	            $(el).find('.field-body').append('<div class="body-text"></div>');
	            $(el).find('.field-body').find('.body-text').text($(el).find('.field-body').text());

	            // remove only text
	            $(el).find('.field-body').contents().filter(function () {
	              return this.nodeType === 3;
	            }).remove();
	          } else {
	            $(el).find('.field-body').children().wrapAll('<div class="body-text">');
	          }
	        }

	        var originalText = $(el).find('.field-body').find('.body-text').text();
	        if ($(el).find('.field-body').find('.body-text').height() > 87) {
	          $(el).find('.field-body').addClass('content-hidden');
	          $(el).find('.field-body').append('<span class="expand read-more">Read more</span>');
	          $(el).find('.field-body').find('.body-text').text(truncate($(el).find('.field-body').find('.body-text').text(), 175));
	        }

	        $(el).find('.expand').on('click', function (e) {
	          var self = $(e.currentTarget);

	          if (self.hasClass('read-more')) {
	            self.removeClass('read-more').addClass('read-less');
	            self.html('Read less');
	            self.parent().removeClass('content-hidden');
	            self.parent().find('.body-text').text(originalText);
	          } else {
	            self.removeClass('read-less').addClass('read-more');
	            self.html('Read more');
	            self.parent().addClass('content-hidden');
	            self.parent().find('.body-text').text(truncate($(el).find('.field-body').find('.body-text').text(), 175));
	          }
	        });
	      });
	    }

	    // Focus/Sector navigation links show more / show less
	    $('.focus-navigation .navigation-links, .page-intro > ul.menu').each(function (i, el) {
	      var $list = $(el);
	      var $items = $list.children('li');
	      var visibleItemsCount = 6;

	      if ($items.length <= visibleItemsCount) {
	        return;
	      }

	      // Prevent duplicate init if init() is called more than once.
	      if ($list.hasClass('navigation-links--initialized')) {
	        return;
	      }

	      $list.addClass('navigation-links--initialized');

	      var $extraItems = $items.slice(visibleItemsCount);
	      var $moreWrapper = $('<li class="navigation-links__more-wrapper"></li>');
	      var $moreList = $('<ul class="navigation-links__more-list"></ul>');

	      $extraItems.appendTo($moreList);
	      $moreWrapper.append($moreList);

	      var $toggleItem = $('\n        <li class="navigation-links__toggle-item">\n          <a href="#" class="navigation-links__toggle-link" aria-expanded="false">\n            Show more +\n          </a>\n        </li>\n      ');

	      $items.eq(visibleItemsCount - 1).after($moreWrapper, $toggleItem);

	      $moreList.hide();

	      var $toggleLink = $toggleItem.find('.navigation-links__toggle-link');

	      $toggleLink.on('click', function (event) {
	        event.preventDefault();

	        var isExpanded = $toggleLink.attr('aria-expanded') === 'true';

	        if (isExpanded) {
	          $moreList.stop(true, true).slideUp(300, function () {
	            $toggleLink.attr('aria-expanded', 'false').text('Show more +');
	          });
	        } else {
	          $moreList.stop(true, true).slideDown(300, function () {
	            $toggleLink.attr('aria-expanded', 'true').text('Show less -');
	          });
	        }
	      });
	    });
	  }
	};

	exports.default = ReadMoreLess;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _global = __webpack_require__(4);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Search = {
	    /*-------------------------------------------------------------------------------
	    	# Cache dom and strings
	    -------------------------------------------------------------------------------*/
	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        var $body = $('body');
	        var $domSearchBlock = $('#block-searchblock');
	        var $domSearchForm = $('#search-form');
	        //$domSearchForm.clone().appendTo($('.c-header__menu'));
	        //$domSearchForm.remove();
	        $domSearchForm.detach().appendTo($('.c-header__menu')); // need this for form validation
	        var $domClonedForm = $('#search-form');
	        $domClonedForm.prepend('<div class="font-icon-close"></div>');

	        $domSearchBlock.on('click', function () {
	            $domClonedForm.toggleClass('search-open');
	            var $input = $domSearchForm.find('.form-search');

	            setTimeout(function () {
	                $input.focus();
	            }, 500);
	        });

	        var $domIconClose = $('.font-icon-close');
	        $domIconClose.on('click', function () {
	            $domClonedForm.toggleClass('search-open');
	        });

	        // $domClonedForm.find('#edit-submit').on('click', () => {
	        //     $domClonedForm.removeClass('search-open')
	        // })

	        var loader = $('<div class="ajax-progress-fullscreen ajax-progress-fullscreen--search"></div>');
	        $domClonedForm.find('#edit-submit').on('click', function () {
	            $body.append(loader);
	        });
	        $(window).on('unload', function () {
	            loader.remove();
	        });

	        _global2.default.functions.escKey(function () {
	            $domClonedForm.removeClass('search-open');
	        });

	        /**
	         * For translate
	        */
	        var searchTranslate = Drupal.t('Search');

	        var $searchMenuItem = $('#block-searchblock');
	        $searchMenuItem.text(searchTranslate);

	        var $searchButton = $('.form-item-search-api-fulltext label');
	        $searchButton.text(searchTranslate);

	        /**
	         * Campaigns
	        */
	        var $filters = $('.page-campaigns .view-filters');
	        var $resetButton = $filters.find('input[id*="edit-reset"]');

	        // hide search results if not searched or filtered
	        if (!$resetButton.length) {
	            $filters.nextUntil('.view-footer').hide();
	        } else {
	            $filters.nextUntil('.view-footer').show();
	        }
	    }
	};

	exports.default = Search;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2 = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSelect: $('select'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// drupal fix for multilingual
			var selectPlaceholder = Drupal.t("Select an option");
			var downloadPlaceholder = Drupal.t("Download photo");

			var $domCountrySelect = $('select[id*="edit-field-country-target-id"]');
			var $editResolution = $('.page-node-photography_competition select[id*=edit-resolution]');

			$domCountrySelect.select2({
				placeholder: '' + selectPlaceholder
			});

			Select2.$domSelect.select2({
				placeholder: '' + selectPlaceholder
			});

			$editResolution.select2({
				placeholder: '' + downloadPlaceholder
			});
		}
	};

	exports.default = Select2;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _select = __webpack_require__(18);

	var _select2 = _interopRequireDefault(_select);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2Ajax = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			$(document).ajaxComplete(function () {
				_select2.default.init();
				$('select[id*="edit-field-year"]').select2();
				$('select[id*="edit-field-in-focus"]').select2();
				$('select[id*="edit-field-sector"]').select2();
				$('select[id*="edit-field-region"]').select2();
				$('select[id*="edit-type"]').select2();
				$('select[id*="edit-field-transport-sector"]').select2();
				$('select[id*="edit-field-tags"]').select2();
			});
		}
	};

	exports.default = Select2Ajax;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSlider: $('.js-slider'),
		$domSliderBanner: $('.js-slider-banner'),
		$domHomeSlider: $('.js-home-slider'),

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			var $domRegionSlider = $('#block-views-block-region-slider-block-1 .view-content');

			$domRegionSlider.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: true,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: true,
				fade: true,
				autoplaySpeed: 4000
			});

			var $photoPrizeSlider = $('#block-photoprize2024pageslider .field-field_images');

			$photoPrizeSlider.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: true,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: true,
				fade: true,
				autoplaySpeed: 4000
			});

			$photoPrizeSlider.on('afterChange', function (event, slick, currentSlide) {
				var currentSlideDom = $(slick.$slides.get(currentSlide));
				var $caption = currentSlideDom.find('.field-field_caption');

				var $wrapper = $('.dots-caption-wrapper');

				$wrapper.find('.field-field_caption').remove();
				$caption.clone().appendTo($wrapper);
			});

			// Congress focus page slider
			var $submissionsClosedSlider = $('#block-itf-photoprize2024pageslidersubmissionsclosed .field-field_images, .page-taxonomy-in_focus #block-congresscaptures .field-field_images');

			$submissionsClosedSlider.slick({
				infinite: false, // important
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				pauseOnHover: true,
				pauseOnFocus: true,
				arrows: true,
				dots: false,
				fade: false, // important
				autoplay: true,
				autoplaySpeed: 4000,
				centerMode: true,
				centerPadding: '25%',
				// adaptiveHeight: true

				responsive: [{
					breakpoint: 992,

					// settings: {
					// 	slidesToShow: 1.25,
					//     centerMode: false,
					// }

					settings: {
						slidesToShow: 1,
						centerPadding: '0',
						centerMode: false
					}
				}]
			});

			// const $congressCapturesSlider = $('.paragraph--type--content-block .field-field_images');

			// $submissionsClosedSlider.slick({
			// 	infinite: false, // important
			// 	slidesToShow: 1,
			// 	slidesToScroll: 1,
			// 	speed: 1000,
			// 	pauseOnHover: true,
			// 	pauseOnFocus: true,
			// 	arrows: true,
			// 	dots: false,
			// 	fade: false, // important
			// 	autoplay: true,
			// 	autoplaySpeed: 4000,
			// 	centerMode: true,
			// 	centerPadding: '25%',
			// 	// adaptiveHeight: true

			// 	responsive: [{
			//         breakpoint: 992,

			//         settings: {
			// 			slidesToShow: 1.25,
			//             centerMode: false,
			//         }
			//     }]
			// });

			// slider
			Sliders.$domSlider.slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: false,
				dots: true,
				responsive: [{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}]
			});

			// Banner Slider
			Sliders.$domSliderBanner.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: true,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: true,
				fade: true,
				autoplaySpeed: 4000
			});

			Sliders.$domHomeSlider.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: true,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: true,
				fade: true,
				autoplaySpeed: 4000,
				rtl: false
			});

			//civil aviation

			var $domPeopleBlock = $('.block-list').eq(0).children('.field-field_list');
			var $domAffiliatesBlock = $('.block-list').eq(1).children('.field-field_list');
			var $domPeopleBlock2 = $('.block-list').eq(0).children('.field-field_list_people');
			var $domAffiliatesBlock2 = $('.block-list').eq(1).children('.field-field_list_affiliates');

			$domPeopleBlock2.children().detach().appendTo($domPeopleBlock);
			$domAffiliatesBlock2.children().detach().appendTo($domAffiliatesBlock);

			// //people slider
			// $domPeopleBlock.slick({
			// 	slidesToShow: 6,
			// 	slidesToScroll: 1,
			// 	infinite: false,
			// 	vertical: true,
			// 	autoplay: false,
			// 	arrows: true,
			// 	dots: false,
			// })

			// $domPeopleBlock.find('.slick-prev, .slick-next').detach().prependTo($domPeopleBlock.parent()).wrapAll('<div class="slick-nav"></div>');

			// //affiliates slider
			// $domAffiliatesBlock.slick({
			// 	slidesToShow: 3,
			// 	slidesToScroll: 1,
			// 	infinite: false,
			// 	vertical: true,
			// 	autoplay: false,
			// 	arrows: true,
			// 	dots: false,
			// })

			// $domAffiliatesBlock.find('.slick-prev, .slick-next').detach().prependTo($domAffiliatesBlock.parent()).wrapAll('<div class="slick-nav"></div>');
		}
	};

	exports.default = Sliders;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var SliderVideo = {
	    /*-------------------------------------------------------------------------------
	    # Cache dom and strings
	    -------------------------------------------------------------------------------*/

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        var $slides = $('.slick-slide');

	        $slides.each(function (i, el) {
	            var $video = $(el).find('video');
	            var $iframe = $(el).find('iframe');

	            if ($video.length) {
	                var $img = $video.parent().parent().find('img');

	                if ($img.length) {
	                    $img.css('display', 'none');
	                }

	                $video.prop('loop', true);
	                $video.prop('controls', false);
	                //$video.trigger('play');
	                $video.get(0).play();
	            }

	            if ($iframe.length) {
	                var _$img = $iframe.parent().parent().parent().find('img');

	                if (_$img.length) {
	                    _$img.css('display', 'none');
	                }
	            }
	        });
	    }
	};

	exports.default = SliderVideo;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(4);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Sticky = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$header: $('.js-header'),
		$content: $('.js-site-content'),
		classSticky: 'sticky-header',
		classStickyContent: 'sticky-content',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			$(window).on('scroll', function () {
				if ($(window).scrollTop() >= 30) {
					Sticky.$content.addClass(Sticky.classStickyContent);
					Sticky.$header.addClass(Sticky.classSticky);
				} else {
					Sticky.$content.removeClass(Sticky.classStickyContent);
					Sticky.$header.removeClass(Sticky.classSticky);
				}
			});
		}
	};

	exports.default = Sticky;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();

	"use strict"; // jshint ignore:line
	var CongressLoadMore = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $wrapper: $('.paragraph--type--related-content'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    var loadMoreText = Drupal.t('Load more');

	    var $buttonAppend = '<button class="e-btn load-more-button">' + loadMoreText + '</button>';

	    CongressLoadMore.$wrapper.each(function (i, el) {
	      var $el = $(el);

	      var $articles = $el.find('.field-field_related_content > .field--item');

	      var articlesLength = $articles.length;

	      var viewArticle = 6;
	      var $nextAll = $articles.eq(viewArticle - 1).nextAll();
	      var $container = $articles.closest('.page-taxonomy-in_focus .paragraph--type--related-content, .page-node-global_basic_page .paragraph--type--related-content, .page-node-campaigns .paragraph--type--related-content');

	      var page = 0;

	      if (articlesLength > viewArticle) {
	        $nextAll.addClass('hide');
	        $container.append($buttonAppend);

	        loadMore($container, page, $nextAll, viewArticle, articlesLength);
	      }
	    });

	    function loadMore($container, page, $nextAll, viewArticle, articlesLength) {
	      var $button = $container.find('.load-more-button');

	      $button.on('click', function () {
	        page += 1;

	        $nextAll.slice(0, viewArticle * page).removeClass('hide');

	        if (viewArticle + viewArticle * page >= articlesLength) {
	          $button.remove();
	        }
	      });
	    }
	  }
	};

	exports.default = CongressLoadMore;

/***/ })
/******/ ]);